<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Numeração Guia</th>
          <th>Convênios</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="especialidade in especialidades" :key="especialidade._id">
          <td>{{ especialidade.nome }}</td>
          <td>{{
            especialidade.codigoNumeracaoGuia != null
              ? especialidade.codigoNumeracaoGuia
              : '-'
          }}</td>
          <td>
            <button
              data-test-id="button-exibiralertavalores-1"
              style="padding: 0; margin: 0"
              class="btn btn-xs btn-link"
              @click="
                exibirAlertaValores(
                  'Convênios',
                  especialidade.convenios,
                  ['nome', '_valor'],
                  ['Nome', 'Valor']
                )
              "
            >
              Ver todos
            </button>
          </td>
          <td>{{ especialidade.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              id="botaoEditar"
              v-tooltip="'Editar'"
              data-test-id="link-botaoeditar"
              :to="'/especialidade/cadastro/' + especialidade._id"
              name="botaoEditar"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'

export default {
  name: 'EspecialidadeTabela',
  mixins: [alertaMixin],
  props: {
    especialidades: {
      type: Array,
      required: true,
    },
  },
}
</script>
